import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { IonicModule } from '@ionic/angular';
import { TitleContentComponent, CustomValidatorModule } from 'ngx-zcs-components';

import { EvchargeConfigComponent } from './evcharge-config.component';
import { BlockTitleComponent } from '../components/block-title/block-title.component';

@NgModule({
  declarations: [
    EvchargeConfigComponent,
  ],
  exports: [
    EvchargeConfigComponent,
  ],
  imports: [
    BlockTitleComponent,
    CommonModule,
    CustomValidatorModule,
    IonicModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSlideToggleModule,
    ReactiveFormsModule,
    TitleContentComponent,
  ]
})
export class EvchargeConfigModule { }
